import { useEffect, useState } from "react"
import { ButtonInput } from "../../shared/Inputs/ButtonInput";
import useApiHelper from "../../../hooks/useApiHelper";

export default function PartsLookupCell({
  priceSetting,
  info,
}: { priceSetting: any, info: any }) {
  const { get } = useApiHelper();
  const [checked, setChecked] = useState(priceSetting.partsLookupPrice ?? false);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    setChecked(priceSetting.partsLookupPrice != null);

    var disable = false;
    if (priceSetting.partsLookup == false || priceSetting.partsLookup == null) disable = true;
    if (priceSetting.make == null || priceSetting.make == '' || priceSetting.model == null || priceSetting.model == '') disable = true;
    if ((priceSetting.fromYear == null || priceSetting.fromYear == 0) && (priceSetting.toYear == null || priceSetting.toYear == 0)) disable = true;
    
    setDisabled(disable);
  }, [priceSetting]);

  const handleClick = () => {
    if (disabled) return;

    get<any>(`/priceSetting/generic/lookup/${priceSetting.id}`).then((priceSetting) => {
      setChecked(true);
      priceSetting.partsLookupPrice = priceSetting.partsLookupPrice;
      info.table.options.meta?.updateData(info.row.index, info.column.id, priceSetting.partsLookupPrice);
    }).catch((error) => {
      console.error("Error fetching parts lookup price:", error);
    });
  }
  
  
  if (checked) return (
    <span className={`${disabled ? "text-red-600" : "text-green-600"}  font-bold`}>
      £{priceSetting.partsLookupPrice?.toFixed(2)}
    </span>
  );

  return (
    <ButtonInput
      label={"Estimate"}
      onClick={handleClick}
      classes={"!px-2 !py-1 !text-xs"}
      isSubmit={false}
      disabled={disabled}
    />
  )
}